import { IServiceFamilyMoveState } from './state';
import { IServiceFamilyMoveAction } from './action';
import { validateInput } from 'commons/ZimssaHelper';

export const defaultState: IServiceFamilyMoveState = {
  isFranchise: undefined,
  franchiseName: '',
  arrangeLicenseImage: '',
  indemnityInsuranceImage: '',
  familyMoveValid: false,
  businessRegistrationName: '',
  businessRegistrationDetailAddress: '',
};

export interface IServiceFamilyMoveReducer {
  (
    state: IServiceFamilyMoveState,
    action: IServiceFamilyMoveAction
  ): IServiceFamilyMoveState;
}

export default function serviceFamilyMoveReducer(
  state: IServiceFamilyMoveState,
  action: IServiceFamilyMoveAction
): IServiceFamilyMoveState {
  const { type, value } = action;
  switch (type) {
    case 'SET_STATE':
      if (typeof value === 'object') {
        state = value || state;
      } else {
        state = defaultState;
      }
      break;
    default:
      state = { ...state, [type]: value };
      break;
  }

  state = {
    ...state,
    familyMoveValid:
      validateInput(state?.arrangeLicenseImage?.trim()) &&
      validateInput(state?.businessRegistrationName?.trim()) &&
      validateInput(state?.businessRegistrationDetailAddress?.trim()),
  };

  if (state.isFranchise) {
    if (!validateInput(state.franchiseName.trim())) {
      state = { ...state, familyMoveValid: false };
    }
  }

  return state;
}
